import { useQuery } from "@tanstack/react-query";
import { Color } from "../types";
import { get } from "../services/restClient";
import { Endpoint, setEndpoint } from "../services/endpoints";
import { queryClient } from "../hooks/queryClient";

const colorKeys = {
    all: ["color"] as const,
    lists: () => [...colorKeys.all, "list"] as const,
    list: (filters: string) => [...colorKeys.lists(), { filters }] as const,
    details: () => [...colorKeys.all, "detail"] as const,
    detail: (id: string) => [...colorKeys.details(), id] as const,
};

const getProductColors = async () => {
    const data = await get<Color[]>(setEndpoint(Endpoint.colors), {
        requireAuth: true,
    });
    return data;
};

export const useGetProductColors = () => {
    return useQuery({ queryKey: ["color"], queryFn: () => getProductColors() });
};

export const prefetchProductColors = () => {
    return queryClient.prefetchQuery({
        queryKey: ["color"],
        queryFn: () => getProductColors(),
    });
};
